import { Component, ElementRef, ViewChild, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MsgBoxComponent } from 'src/app/common/msg-box';
import { TokboxService } from '../tokbox-viewer/tokbox.service';

declare var jQuery: any;

const publish = () => {

};

@Component({
  selector: 'app-publisher',
  templateUrl: './publisher.component.html'
})

export class PublisherComponent implements OnInit {
  @ViewChild('publisherDiv1', { static: true }) publisherDiv: ElementRef;

  @ViewChild('msgbox') msgbox: MsgBoxComponent;
  @Input() session: OT.Session;
  @Input() name: string;
  @Output() videoClosed = new EventEmitter();
  publisher: OT.Publisher;
  publishing: Boolean;
  isAudioOnly = false;
  constructor(private opentokService: TokboxService) {
    this.publishing = false;
  }

  ngOnInit() {
    const OT = this.opentokService.getOT();
    this.publisher = OT.initPublisher(this.publisherDiv.nativeElement,
      {
        insertMode: 'append',
        name: this.name
      });
  }

  public closeVideo() {
    this.videoClosed.emit();
  }

  publish() {
    this.session.publish(this.publisher, (err) => {
      if (err) {
        switch (err.name) {
          case 'OT_NOT_CONNECTED':
            this.msgbox.alert('Publishing your video failed. You are not connected to the internet.Please close the browser and try again later.');
            break;
          case 'OT_CREATE_PEER_CONNECTION_FAILED':
            this.msgbox.alert('Publishing your video failed. This could be due to a restrictive firewall.Please close the browser and try again later.');
            break;
          case 'OT_TIMEOUT':
            this.msgbox.alert('Request timed out, publishing your video failed. Please close the browser and try again later.');
            break;
          // default:
          //   this.msgbox.alert("An unknown error occurred while trying to
          // publish your video. Please close the browser and try again later.");
        }
        // this.publisher.destroy();
        // this.publisher = null;
      } else {
        this.publishing = true;
      }
    });
  }

  disconnect() {
    if (this.session) {
      this.session.unpublish(this.publisher);
      this.session.disconnect();
      this.session = null;
    }
  }
  sessionDisconnect() {
    if (this.session) {
      if (this.publisher) {
        this.session.unpublish(this.publisher);
        this.publisher.destroy();
        this.publisher = null;
      }
      this.session.disconnect();
      this.session = null;
    }
  }
  public audio() {
    this.publisher.publishVideo(false);
    this.isAudioOnly = true;
  }
  public video() {
    this.publisher.publishVideo(true);
    this.isAudioOnly = false;
  }
}
